@import 'styles/mixins';
@import 'styles/variables';

.container {
  :global .ant-modal-content {
    border-radius: 16px;
    @include shadow-3;
  }

  :global .ant-modal-body {
    padding: 0;
  }
}

.header {
  display: flex;
  align-items: center;
  padding: 24px;
  @include xxl-semibold;
  color: $grey-90;
}

.body {
  margin: 0 24px;
  @include lg-regular;
  color: $grey-90;
}

.footer {
  display: flex;
  justify-content: space-between;
  padding: 24px 16px 16px 16px;
}
